import React, { useState, useEffect } from 'react';
import './AddUnitsModal.css';

const AddUnitsModal = ({ isOpen, onClose, onAdd, kitType, actionLoading }) => {
    const [quantity, setQuantity] = useState(10);

    useEffect(() => {
        if (isOpen) {
            setQuantity(10);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleAdd = () => {
        if (quantity > 0) {
            onAdd(quantity);
        }
    };

    return (
        <div className="GORDAM-modal-overlay">
            <div className="GORDAM-modal-content">
                <div className="GORDAM-modal-header">
                    <h2>Add Units to {kitType.Name}</h2>
                    <button onClick={onClose} className="GORDAM-close-btn">×</button>
                </div>
                <div className="GORDAM-form-group">
                    <label htmlFor="add-quantity">How many units to add?</label>
                    <input
                        id="add-quantity"
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                        min="1"
                        className="GORDAM-input"
                    />
                </div>
                <div className="GORDAM-info">
                    <p>This will create <strong>{quantity} new kit unit{quantity !== 1 ? 's' : ''}</strong> for {kitType.Name}.</p>
                </div>
                <div className="GORDAM-actions">
                    <button className="GORDAM-btn GORDAM-btn-secondary" onClick={onClose} disabled={actionLoading}>Cancel</button>
                    <button
                        className="GORDAM-btn GORDAM-btn-primary"
                        onClick={handleAdd}
                        disabled={actionLoading || quantity <= 0}
                    >
                        {actionLoading ? (
                            <>
                                <i className="fas fa-spinner fa-spin"></i> Adding...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-plus"></i> Add {quantity} Unit{quantity !== 1 ? 's' : ''}
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddUnitsModal;
